<template>
  <div class="mb-3">
    <label class="form-label" for="select-language"> Select language </label>
    <div class="form-text">Which language would you like to use?</div>
    <select
      id="select-language"
      class="form-select"
      v-model="language"
      @change="emitChange"
    >
      <option
        v-for="option in languages"
        :key="option.value"
        :value="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { defineProps, defineEmits } from "vue";

const store = useStore();

const props = defineProps({
  enabledFor: {
    type: String,
    default: "language_enabled",
  },
  defaultlanguage: {
    type: Number,
    default: 38,
  },
});

const emit = defineEmits(["languagechange"]);

const language = ref(38);
const languages = ref([]);

onMounted(() => {
  language.value = props.defaultlanguage;
  languages_get();
});

const emitChange = () => {
  emit("languagechange", language.value);
};

const languages_get = () => {
  languages.value = [];
  const filter = {};
  filter[props.enabledFor] = {
    operator: "=",
    value: "1",
  };
  const payload = {
    table_name: "g_languages",
    filter,
  };

  // Using the store dispatch method directly with Composition API
  store.dispatch("records_readall", payload).then((resp) => {
    for (let i = 0; i < resp.data.result.length; i++) {
      languages.value.push({
        value: resp.data.result[i].id,
        text: resp.data.result[i].language_name,
      });
    }
  });
};
</script>

<style></style>
